/**
 * Why a `DunningRunItem` was SKIPPED. Set when item status becomes SKIPPED.
 *
 * The "eligibility" values (`PAID`, `WRITTEN_OFF`, `INVOICE_CANCELLED`,
 * `ALREADY_DUNNED`, `NO_LONGER_OVERDUE`) are emitted by the worker's per-item
 * re-validation. `DUNNING_BLOCKED` is set when an invoice carries an active
 * per-invoice dunning block (Mahnsperre) at processing time — a deliberate
 * exclusion, not a failure (PRD #988). `CANCELED` is set for items left
 * PENDING when a user-initiated cancel of the run is observed. `ORPHANED` is
 * set by the daily sweeper for items left PENDING in an IN_PROGRESS run older
 * than the orphan threshold.
 *
 * Persisted as the string value. The UI shows `DUNNING_RUN_SKIP_REASON_LABEL`,
 * never the value itself.
 */
export var DunningRunSkipReason;
(function (DunningRunSkipReason) {
    DunningRunSkipReason["PAID"] = "paid";
    /** The invoice's rest was ausgebucht between selection and processing (TM-9111). */
    DunningRunSkipReason["WRITTEN_OFF"] = "written_off";
    DunningRunSkipReason["INVOICE_CANCELLED"] = "invoice_cancelled";
    DunningRunSkipReason["ALREADY_DUNNED"] = "already_dunned";
    DunningRunSkipReason["NO_LONGER_OVERDUE"] = "no_longer_overdue";
    DunningRunSkipReason["DUNNING_BLOCKED"] = "dunning_blocked";
    DunningRunSkipReason["CANCELED"] = "canceled";
    DunningRunSkipReason["ORPHANED"] = "orphaned";
})(DunningRunSkipReason || (DunningRunSkipReason = {}));
/** German label of each skip reason, as the Mahnlauf result lists it. */
export const DUNNING_RUN_SKIP_REASON_LABEL = {
    [DunningRunSkipReason.PAID]: 'bezahlt',
    [DunningRunSkipReason.WRITTEN_OFF]: 'ausgebucht',
    [DunningRunSkipReason.INVOICE_CANCELLED]: 'storniert',
    [DunningRunSkipReason.ALREADY_DUNNED]: 'bereits gemahnt',
    [DunningRunSkipReason.NO_LONGER_OVERDUE]: 'nicht mehr überfällig',
    [DunningRunSkipReason.DUNNING_BLOCKED]: 'Mahnsperre',
    [DunningRunSkipReason.CANCELED]: 'abgebrochen',
    [DunningRunSkipReason.ORPHANED]: 'nicht verarbeitet',
};
//# sourceMappingURL=dunning-run-skip-reason.enum.js.map